import {
  STATUS_NOT_REQUESTED,
  STATUS_LOADING,
  STATUS_SUCCESS,
  STATUS_ERROR,
} from 'const';
import {
  UPLOAD_FILES_REQUEST,
  UPLOAD_FILES_SUCCESS,
  UPLOAD_FILES_ERROR,
  GET_UPLOAD_HISTORY_REQUEST_START,
  GET_UPLOAD_HISTORY_SUCCESS,
  GET_UPLOAD_HISTORY_ERROR,
  MORE_UPLOAD_HISTORY_SUCCESS,
  MORE_UPLOAD_HISTORY_REQUEST,
  MORE_UPLOAD_HISTORY_ERROR,
  UPLOAD_FILES_RESET_STATUS,
  INIT_UPLOAD_FILES_PAGE,
  DOWNLOAD_DOCUMENT_REQUEST,
  DOWNLOAD_DOCUMENT_SUCCESS,
  DOWNLOAD_DOCUMENT_ERROR,
  GET_UPLOADERS_HISTORY_SUCCESS,
  MARK_DOCUMENT_AS_MISTAKEN_SUCCESS,
} from '../actions';

const getTypicalStoreStructure = () => ({
  uploadStatus: STATUS_NOT_REQUESTED,
  uploadersHistory: [],
  uploadHistory: {
    data: [],
    meta: {},
    historyStatus: STATUS_NOT_REQUESTED,
    error: {},
  },
  downloadingDocumentsList: [],
  error: {},
});

const initialState = getTypicalStoreStructure();

export const uploadDocuments = (state = initialState, action) => {
  switch (action.type) {
    case GET_UPLOAD_HISTORY_REQUEST_START:
      return {
        ...state,
        uploadHistory: {
          ...state.uploadHistory,
          historyStatus: STATUS_LOADING,
        },
        uploadersHistory: state.uploadersHistory,
      };

    case MORE_UPLOAD_HISTORY_REQUEST:
      return {
        ...state,
        uploadHistory: {
          ...state.uploadHistory,
          historyStatus: STATUS_LOADING,
        },
      };

    case GET_UPLOAD_HISTORY_SUCCESS: {
      const { documents, meta } = action.payload;
      return {
        ...state,
        uploadHistory: {
          ...state.uploadHistory,
          data: documents,
          meta,
          historyStatus: STATUS_SUCCESS,
        },
      };
    }
    case MARK_DOCUMENT_AS_MISTAKEN_SUCCESS: {
      const { document } = action.payload;

      return {
        ...state,
        uploadHistory: {
          ...state.uploadHistory,
          data: state.uploadHistory.data.map((item) =>
            item.id === document.id ? document : item
          ),
        },
      };
    }
    case MORE_UPLOAD_HISTORY_SUCCESS: {
      const { documents, meta } = action.payload;
      return {
        ...state,
        uploadHistory: {
          ...state.uploadHistory,
          data: [...state.uploadHistory.data, ...documents],
          meta,
          historyStatus: STATUS_SUCCESS,
        },
      };
    }

    case GET_UPLOAD_HISTORY_ERROR:
    case MORE_UPLOAD_HISTORY_ERROR:
      return {
        ...state,
        uploadHistory: {
          ...state.uploadHistory,
          error: action.payload.error,
          historyStatus: STATUS_ERROR,
        },
      };

    case DOWNLOAD_DOCUMENT_REQUEST:
      return {
        ...state,
        downloadingDocumentsList: [
          ...state.downloadingDocumentsList,
          action.payload.fileId,
        ],
      };

    case DOWNLOAD_DOCUMENT_SUCCESS:
    case DOWNLOAD_DOCUMENT_ERROR:
      return {
        ...state,
        downloadingDocumentsList: state.downloadingDocumentsList.filter(
          (id) => id !== action.payload.fileId
        ),
      };

    case UPLOAD_FILES_REQUEST:
      return {
        ...state,
        uploadStatus: STATUS_LOADING,
      };

    case UPLOAD_FILES_SUCCESS: {
      const { documents } = action.payload;
      return {
        ...state,
        uploadStatus: STATUS_SUCCESS,
        uploadHistory: {
          ...state.uploadHistory,
          data: [...state.uploadHistory.data, ...documents],
        },
      };
    }

    case UPLOAD_FILES_ERROR:
      return {
        ...state,
        uploadStatus: STATUS_ERROR,
        error: action.payload.error,
      };

    case UPLOAD_FILES_RESET_STATUS:
      return {
        ...state,
        uploadStatus: STATUS_NOT_REQUESTED,
      };

    case GET_UPLOADERS_HISTORY_SUCCESS:
      return {
        ...state,
        uploadersHistory: action.payload,
      };

    case INIT_UPLOAD_FILES_PAGE:
      return initialState;

    default:
      return state;
  }
};
